(function($) {
      
  $(document).ready(function() {
    if ( $('.custom_row_flags .three-block-layout .col-block').length > 2 ) {
      $('.custom_row_flags .three-block-layout').slick({
         loop: true,
         rtl: true,
         slidesToShow: 4,
         prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              fade: false,
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              fade: false,
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 550,
            settings: {
              fade: false,
              slidesToShow: 1,
            }
          }
        ],
       });
    }
   

    // if( $(window).width() < 992px && $('.featured-blog .col-block').length > 2 ) {
    //   $('.featured-blog .three-block-layout').slick({
    //      loop: false,
    //       infinite: false,
    //      rtl: false,
    //      slidesToShow: 3,
    //      prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
    //     nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
    //     responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           fade: false,
    //           slidesToShow: 3,
    //         }
    //       },
    //       {
    //         breakpoint: 768,
    //         settings: {
    //           fade: false,
    //           slidesToShow: 2,
    //         }
    //       },
    //       {
    //         breakpoint: 550,
    //         settings: {
    //           fade: false,
    //           slidesToShow: 1,
    //         }
    //       }
    //     ],
    //    });
    // }

    $(window).on('scroll', function() {
      if ( $(window).scrollTop() > 200) {
        $('.page-header').addClass('sticky');
      } else {
        $('.page-header').removeClass('sticky');
      }
    });
  });
})(window.jQuery)